import store from "../../redux/store";
import { getAxiosInstance } from "../ApiConfig";
import { setCallingData } from "../../redux/CrmReduxCalls/ProductInteApiCalls";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;


async function getCalltoken() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getTwilioToken`, { headers });
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyCommunication() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCommunicationByCompany`, { headers });
        store.dispatch(setCallingData(response.data));
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAiIntegrationByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAiIntegrationByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationDelte(communicationId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteCommunication/${communicationId}`, { headers })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function DeleteAiIntegration(aiIntegrationId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAiIntegration/${aiIntegrationId}`, { headers })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCommunication`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CommunicationUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCommunication/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ComunicationDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCommunicationById/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationNumbers(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/twilio-numbers`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createAiIntegration(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAiIntegration`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UpdateAiIntegration(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAiIntegration/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    DeleteAiIntegration,
    findAiIntegrationByCompany,
    CommunicationDelte,
    getCompanyCommunication,
    CommunicationSave,
    CommunicationUpdate,
    ComunicationDetailData,
    getCalltoken,
    CommunicationNumbers,
    createAiIntegration,
    UpdateAiIntegration,
}